<!-- <div id="mydailer" class="chat-popup">

  <iframe *ngIf="iframeInitialized" allow="camera *; geolocation *; microphone *; autoplay *; display-capture *"
    style="height: 500px;" #myFrame src="https://crm-app.doocti.com/" (load)="callANumber()">
  </iframe>


  <div *ngIf="dialerShow" style="background-color: white;" fxLayoutAlign="center center" fxLayoutGap="10px">
    <button [attr.guide]="'doocti-call-btn-1' + '__' + sanitizeUrl(url)" mat-button *ngIf="dialerShow" (click)="callANumber()" class="call-btn">Call</button>
    <button [attr.guide]="'doocti-call-btn-2' + '__' + sanitizeUrl(url)" mat-button *ngIf="dialerShow" (click)="closeModal()" class="cls-btn">Close</button>
  </div>
</div> -->


<div id="mydailer" class="chat-popup" [ngClass]="{'minimized': isMinimized}">
  <iframe *ngIf="iframeInitialized" allow="camera *; geolocation *; microphone *; autoplay *; display-capture *" #myFrame
      src="https://app.doocti.com/" [ngStyle]="{'height.px': isMinimized ? 55 : 500}">
  </iframe>
  <div *ngIf="dialerShow" style="background-color: white;" fxLayoutAlign="center center" fxLayoutGap="10px">
      <button [attr.guide]="'doocti-call-btn-3' + '__' + sanitizeUrl(url)" mat-button *ngIf="dialerShow" (click)="callANumber()" class="call-btn">
          Call
      </button>
      <button [attr.guide]="'doocti-call-btn-4' + '__' + sanitizeUrl(url)" mat-button *ngIf="dialerShow" (click)="minimizeToggle()" class="call-btn">
          {{isMinimized ? 'Maximize' : 'Minimize'}}
      </button>
      <button [attr.guide]="'doocti-call-btn-5' + '__' + sanitizeUrl(url)" mat-button *ngIf="dialerShow" (click)="closeModal()" class="cls-btn">Close</button>
  </div>
</div>

<!-- call dialer popup closed-->